module.exports = __webpack_public_path__ + "static/img/CNN-Selected.52c21c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/CNN-Selected.png
// module id = 599
// module chunks = 0